import { useSyncUser } from './useSyncUser';

export const SupabaseRedirect: React.FC = () => {
  useSyncUser();

  return null;
};
